<template>
  <div class="button-wrp">
    <div :class="`item ${v.value === selected ? 'selected' : ''}`" v-for="(v, i) in list" :key="i" @click="handleClick(v)">
      <span>{{v.label}}</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    selected: {
      type: String,
      default: 'taxDisk'
    }
  },
  data () {
    return {
      list: [
        {
          label: '税盘信息',
          value: 'taxDisk'
        },
        {
          label: '销方信息',
          value: 'sellerInfo'
        },
        {
          label: '抄税清卡',
          value: 'clear'
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  activated () {},
  updated () {},
  methods: {
    handleClick (item) {
      this.$emit('radiochange', item)
    }
  }
}
</script>
<style scoped lang='less'>
.button-wrp{
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  background: #D6E4FE;
  border-radius: 6px 6px 0px 0px;
  display: flex;
  .item{
    width: 33.3333%;
    height: 80px;
    text-align: center;
    span{
      line-height: 80px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #8A9EBB;
    }
  }
  .item.selected{
    background: #3278FF;
    position: relative;
    span{
      color: #fff;
    }
  }
  .item.selected:not(:nth-last-child(1)):after{
    position: absolute;
    right: -19px;
    top: 0;
    content: '';
    display: block;
    box-sizing: border-box;
    width: 0;
    height: 42px;
    border-bottom: 84px solid #3278FF;
    border-right: 20px solid transparent;
  }
}
</style>
